angular.module('app').config(providerCreditnotesRouting);

function providerCreditnotesRouting($routeProvider) {
  $routeProvider
    .when('/provider_credit_notes', {
      pageTitle: 'PROVIDER_CREDIT_NOTES',
      template: '<provider-credit-notes-page></provider-credit-notes-page>',
      menu: 'purchases',
      accessPermission: 'index_providercreditnote_accountadmin',
      authReq: true,
    })
    .when('/provider_credit_notes/new', {
      // params: {
      //   billId: null,
      //   billNumber: null,
      //   providerId: null,
      // },
      pageTitle: 'ADD_PROVIDER_CREDIT_NOTE',
      template: '<provider-credit-note-page></provider-credit-note-page>',
      breadcrumb: {
        label: 'PROVIDER_CREDIT_NOTES',
        parent: 'provider_credit_notes',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'create_providercreditnote_accountadmin',
      authReq: true,
    })
    .when('/provider_credit_notes/:id', {
      // params: {
      //   mode: null,
      // },
      pageTitle: 'PROVIDER_CREDIT_NOTE',
      template: '<provider-credit-note-page></provider-credit-note-page>',
      breadcrumb: {
        label: 'PROVIDER_CREDIT_NOTES',
        parent: 'provider_credit_notes',
        ajs: true,
      },
      menu: 'purchases',
      accessPermission: 'show_providercreditnote_accountadmin',
      authReq: true,
    });
}

providerCreditnotesRouting.$inject = ['$routeProvider'];
